import { Label } from "components";
import { Dispatch, FC, SetStateAction } from "react";
import DownloadIcon from "public/download.svg";
import { PropertySurveyEvidenceModal } from "../PropertySurveyEvidenceModal";
import ButtonV2 from "elements/ButtonV2";

interface FileTemplate {
	title: string;
	description: string;
	href: string;
}

const FILE_TEMPLATES: FileTemplate[] = [
	{
		title: "2023 Rent Roll (.XLSX)",
		description:
			"Use this template to report 2023 rent by unit on a monthly basis",
		href: "/2023_Rent_Roll_Template.xlsx",
	},
	{
		title: "2023 Rent Roll (.PDF)",
		description:
			"Use this template to report 2023 rent by unit on a monthly basis",
		href: "/2023_Rent_Roll_Template.pdf",
	},
	{
		title: "2023 Profit Loss (.XLSX)",
		description:
			"Use this template to report 2023 rental income and operating expenses on a monthly basis.",
		href: "/2023_Profit_Loss_Template.xlsx",
	},
	{
		title: "2023 Profit Loss (.PDF)",
		description:
			"Use this template to report 2023 rental income and operating expenses on a monthly basis.",
		href: "/2023_Profit_Loss_Template.pdf",
	},
];

const FileTemplateCard: FC<FileTemplate> = ({ title, description, href }) => {
	return (
		<div className="file-template-card" onClick={e => e.stopPropagation()}>
			<Label>Template</Label>
			<p>{title}</p>
			<p className="file-template-card-description sm">{description}</p>
			<a className="file-template-card-download" href={href} download>
				<p className="sm">Download</p>
				<DownloadIcon />
			</a>
		</div>
	);
};

export const EvidenceModal = (props: {
	setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
	const { setOpen } = props;

	return (
		<PropertySurveyEvidenceModal onAttemptExit={() => setOpen(false)}>
			<p>
				<b>Income Producing</b>
			</p>
			<div className="property-survey-evidence-modal-body-text-container">
				<p className="sm">
					For income-producing property, we need more information to fully
					evaluate your property for an appeal. To move forward with your
					appeal, we need:
					<ul className="mb-1">
						<li className="sm">Previous Year Rent Roll by Unit, by Month</li>
						<li className="sm">Previous Year Profit & Loss Statement</li>
					</ul>
					The information you provide will be used to create an income valuation
					model, which adds context to our own data, and strengthens our case
					for earning you a property tax reduction. Without it, we will be
					unable to earn you a reduction.
					<br />
					<br />
					Don’t have this information readily available? No problem! We’ve made
					templates that are easy to use and usually take just a few minutes to
					complete using the information you probably have on hand already.
				</p>
			</div>
			<div className="property-survey-evidence-modal-image-container-grid">
				{FILE_TEMPLATES.map((props, i) => (
					<FileTemplateCard key={props.href + i} {...props} />
				))}
			</div>
			<ButtonV2
				size="mobile-extra-small"
				onClick={() => setOpen(false)}
				className="mx-auto">
				Back to Question
			</ButtonV2>
		</PropertySurveyEvidenceModal>
	);
};
